import { render } from "./ViewTests.vue?vue&type=template&id=7404fd89"
import script from "./ViewTests.vue?vue&type=script&lang=js"
export * from "./ViewTests.vue?vue&type=script&lang=js"

import "./ViewTests.vue?vue&type=style&index=0&id=7404fd89&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pendingCases/ViewTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7404fd89"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7404fd89', __exports__)) {
    console.log('reload')
    api.reload('7404fd89', __exports__)
  }
  
  module.hot.accept("./ViewTests.vue?vue&type=template&id=7404fd89", () => {
    console.log('re-render')
    api.rerender('7404fd89', render)
  })

}


export default __exports__